module.exports = __webpack_public_path__ + "first-200_front.jpg?c4965779246af733085dede79d16d451";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-200_front.jpg
// module id = 483
// module chunks = 0